(function() {
	'use strict';

	angular
		.module('accesso-pay')
		.factory('AccessoPayUtils', AccessoPayUtils);

	/**
	 * AccessoPay Utils.
	 * @param {Service} $filter $filter
	 * @param {Service} $rootScope $rootScope
	 * @param {Service} $location $location
	 * @param {Service} AppData AppData
	 * @param {Service} BillingService BillingService
	 * @param {Service} CartDataService CartDataService
	 * @param {Service} LegacyCart LegacyCart
	 * @param {Service} CreditCardService CreditCardService
	 * @param {Service} Enums Enums
	 * @param {Service} JSONValidator JSONValidator
	 * @param {Service} Language Language
	 * @param {Service} Package Package
	 * @param {Service} ShippingService ShippingService
	 * @param {Service} StringUtils StringUtils
	 * @param {Service} UserInfo UserInfo
	 * @param {Service} Utilities Utilities
	 * @param {Service} UtilsValidation UtilsValidation
	 * @returns {AccessoPayUtils} The instance
	 * @ngInject
	 */
	function AccessoPayUtils($filter, $rootScope, $location, AppData, BillingService, CartDataService, LegacyCart, CreditCardService, Enums, JSONValidator, Language, Package, ShippingService, StringUtils, TicketUtilsService, UserInfo, Utilities, UtilsValidation) {
		var getLocale = Language.getLocale,
			AUTH_TYPE_ENUMS = Enums.authTypes,
			checkProp = Utilities.safelyCheckPropertyOnObject,
			normalize = StringUtils.normalize,
			validString = UtilsValidation.validString,
			returnOrDefault = UtilsValidation.returnOrDefault,
			validArray = UtilsValidation.validArray,
			validObject = UtilsValidation.validObject,
			wrapObjectToArray = Utilities.wrapObjectToArray,
			getBoolean = Utilities.getBoolean,
			getTenant = TicketUtilsService.getTenant,
			ERROR_PREFIX = '[AccessoPayUtils] ';
		var service = {
			broadcastAnalyticsEvent: broadcastAnalyticsEvent,
			getAllowedDeliveryCountries: getAllowedDeliveryCountries,
			getAmountForPayment: getAmountForPayment,
			getAppConfig: getAppConfig,
			getButtonStyles: getButtonStyles,
			getCheckboxStyles: getCheckboxStyles,
			getDeliveryAmountForSelectedDeliveryMethod: getDeliveryAmountForSelectedDeliveryMethod,
			getDisabledCardTypes: getDisabledCardTypes,
			getDisabledPaymentMethods: getDisabledPaymentMethods,
			getEventInfoForCartItem: getEventInfoForCartItem,
			getFeesDetailsForCart: getFeesDetailsForCart,
			getLabelForDeliveryMethod: getLabelForDeliveryMethod,
			getLanguageForAccessoPay: getLanguageForAccessoPay,
			getLineItems: getLineItems,
			getMerchantId: getMerchantId,
			getOtherConfiguredPayments: getOtherConfiguredPayments,
			getPaymentProviderPaymentNameMapping: getPaymentProviderPaymentNameMapping,
			getRadioButtonStyles: getRadioButtonStyles,
			getStoreColors: getStoreColors,
			getTenantDetails: getTenantDetails,
			getUserBillingDemographics: getUserBillingDemographics,
			getUserShippingDemographics: getUserShippingDemographics,
			hasScheduledPayments: hasScheduledPayments,
			parseUrlOrigin: parseUrlOrigin
		};

		return service;

		/**
		 * Returns default store colors
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {Object} store colors
		 */
		function getStoreColors() {
			var white = '#fff',
				black = '#000',
				defaultBorderColor = '#c6c6c6',
				green = '#49a942',
				lightGreen = '#82ce34',
				darkRed = '#ef013f',
				red = 'red',
				blue = '#0061c5';
			var cssOverrides = JSONValidator.validate('css_overrides', AppData.settings.css_overrides) ? JSON.parse(AppData.settings.css_overrides) : {};
			var styles = {
				buttons: {
					default: {
						backgroundColor: '#f7f7f7',
						borderColor: '#c6c6c6',
						color: black
					},
					defaultActive: {
						backgroundColor: '#d4d4d4',
						borderColor: '#868686',
						color: '#333'
					},
					defaultHover: {
						backgroundColor: '#f7f7f7',
						borderColor: '#c6c6c6',
						color: black
					},
					primary: {
						backgroundColor: '#0061c5',
						borderColor: '#0080ff',
						color: white
					},
					primaryActive: {
						backgroundColor: '#204d74',
						borderColor: '#122b40',
						color: white
					},
					primaryHover: {
						backgroundColor: '#0061c5',
						borderColor: '#0080ff',
						color: white
					},
					warn: {
						backgroundColor: red,
						borderColor: '#c62828',
						color: white
					},
					warnActive: {
						backgroundColor: '#c62828',
						borderColor: '#c62828',
						color: white
					},
					warnHover: {
						backgroundColor: red,
						borderColor: '#c62828',
						color: white
					}
				},
				checkbox: {
					backgroundColor: lightGreen,
					color: white,
					defaultColor: defaultBorderColor
				},
				formPadding: {
					bottom: '1em',
					top: '0px'
				},
				input: {
					default: {
						backgroundColor: white,
						borderColor: '#cccccc',
						hoverColor: white,
						placeholderColor: '#cccccc'
					},
					error: {
						backgroundColor: white,
						borderColor: darkRed
					},
					errorTextColor: darkRed,
					focused: {
						backgroundColor: white,
						borderColor: blue
					}
				},
				layout: {
					backgroundColor: white,
					borderColor: defaultBorderColor,
					labelColor: black,
					textColor: black
				},
				modalBackgroundColor: white,
				radio: {
					backgroundColor: green,
					borderColor: green,
					defaultColor: defaultBorderColor
				}
			};

			if (validObject(cssOverrides)) {
				if (validString(cssOverrides.radioBg)) {
					styles.radio = service.getRadioButtonStyles(returnOrDefault(cssOverrides.radioBg, '', validString), styles.radio);
				}
				if (validString(cssOverrides.checkboxBg)) {
					styles.checkbox = service.getCheckboxStyles(returnOrDefault(cssOverrides.checkboxBg, '', validString), styles.checkbox);
				}
				//Primary Button Styles
				if (validString(cssOverrides.btnPrimary)) {
					styles.buttons.primary = service.getButtonStyles(returnOrDefault(cssOverrides.btnPrimary, '', validString), styles.buttons.primary);
				}
				if (validString(cssOverrides.btnPrimaryHover)) {
					styles.buttons.primaryHover = service.getButtonStyles(returnOrDefault(cssOverrides.btnPrimaryHover, '', validString), styles.buttons.primaryHover);
				} else {
					styles.buttons.primaryHover = styles.buttons.primary;
				}
				if (validString(cssOverrides.btnPrimaryActive)) {
					styles.buttons.primaryActive = service.getButtonStyles(returnOrDefault(cssOverrides.btnPrimaryActive, '', validString), styles.buttons.primaryActive);
				} else {
					styles.buttons.primaryActive = styles.buttons.primary;
				}
				//Default Button Styles
				if (validString(cssOverrides.btnDefault)) {
					styles.buttons.default = service.getButtonStyles(returnOrDefault(cssOverrides.btnDefault, '', validString), styles.buttons.default);
				}
				if (validString(cssOverrides.btnDefaultHover)) {
					styles.buttons.defaultHover = service.getButtonStyles(returnOrDefault(cssOverrides.btnDefaultHover, '', validString), styles.buttons.defaultHover);
				} else {
					styles.buttons.defaultHover = styles.buttons.default;
				}
				if (validString(cssOverrides.btnDefaultActive)) {
					styles.buttons.defaultActive = service.getButtonStyles(returnOrDefault(cssOverrides.btnDefaultActive, '', validString), styles.buttons.defaultActive);
				} else {
					styles.buttons.defaultActive = styles.buttons.default;
				}
				// Warn Button Styles
				if (validString(cssOverrides.btnWarn)) {
					styles.buttons.warn = service.getButtonStyles(returnOrDefault(cssOverrides.btnWarn, '', validString), styles.buttons.warn);
				}
				if (validString(cssOverrides.btnWarnHover)) {
					styles.buttons.warnHover = service.getButtonStyles(returnOrDefault(cssOverrides.btnWarnHover, '', validString), styles.buttons.warnHover);
				} else {
					styles.buttons.warnHover = styles.buttons.warn;
				}
				if (validString(cssOverrides.btnWarnActive)) {
					styles.buttons.warnActive = service.getButtonStyles(returnOrDefault(cssOverrides.btnWarnActive, '', validString), styles.buttons.warnActive);
				} else {
					styles.buttons.warnActive = styles.buttons.warn;
				}
			}

			return styles;
		}

		/**
		 * Returns button styles
		 * @public
		 * @memberof AccessoPayUtils
		 * @param {String} configuredStyles configured styles
		 * @param {Object} defaultStyles default styles
		 * @returns {Object} final styles
		 */
		function getButtonStyles(configuredStyles, defaultStyles) {
			var configuredStyleArray = configuredStyles.split(',');
			return {
				backgroundColor: validString(configuredStyleArray[1]) ? configuredStyleArray[1].trim() : defaultStyles.backgroundColor,
				borderColor: validString(configuredStyleArray[2]) ? configuredStyleArray[2].trim() : defaultStyles.borderColor,
				color: validString(configuredStyleArray[0]) ? configuredStyleArray[0].trim() : defaultStyles.color
			};
		}

		/**
		 * Returns radio button styles
		 * @public
		 * @memberof AccessoPayUtils
		 * @param {String} configuredStyles configured styles
		 * @param {Object} defaultStyles default styles
		 * @returns {Object} final styles
		 */
		function getRadioButtonStyles(configuredStyles, defaultStyles) {
			var configuredStyleArray = configuredStyles.split(',');
			return {
				backgroundColor: validString(configuredStyleArray[0]) ? configuredStyleArray[0].trim() : defaultStyles.backgroundColor,
				borderColor: validString(configuredStyleArray[1]) ? configuredStyleArray[1].trim() : defaultStyles.borderColor,
				defaultColor: defaultStyles.defaultColor
			};
		}

		/**
		 * Returns checkbox styles
		 * @public
		 * @memberof AccessoPayUtils
		 * @param {String} configuredStyles configured styles
		 * @param {Object} defaultStyles default styles
		 * @returns {Object} final styles
		 */
		function getCheckboxStyles(configuredStyles, defaultStyles) {
			var configuredStyleArray = configuredStyles.split(',');
			return {
				backgroundColor: validString(configuredStyleArray[0]) ? configuredStyleArray[0].trim() : defaultStyles.backgroundColor,
				color: defaultStyles.color,
				defaultColor: defaultStyles.defaultColor
			};
		}

		/**
		 * Returns delivery amount for selected delivery method
		 * @public
		 * @memberof AccessoPayUtils
		 * @param {Object[]} deliveryMethods configured delivery methods
		 * @param {String} selectedDeliveryMethod selected delivery method
		 * @throws {Error} when matching delivery method is not found
		 * @returns {Number} delivery amount
		 */
		function getDeliveryAmountForSelectedDeliveryMethod(deliveryMethods, selectedDeliveryMethod) {
			var found = deliveryMethods.find(function findDeliveryMethod(deliveryMethod) {
				return deliveryMethod.id === selectedDeliveryMethod;
			});

			if (found) {
				return found.amount;
			}

			throw new Error(ERROR_PREFIX + 'cannot find matching delivery method');
		}

		/**
		 * Returns label for shipping method
		 * @public
		 * @memberof AccessoPayUtils
		 * @param {Number} price price
		 * @param {String} label label
		 * @returns {String} label
		 */
		function getLabelForDeliveryMethod(price, label) {
			var priceLabel,
				isFree = price === 0;

			if (!validString(label)) {
				return '';
			}

			priceLabel = isFree ? getLocale('ShippingView', 'priceLabel') : $filter('currencyFormatter')(price);

			return label + (validString(priceLabel) ? ' (' + priceLabel + ')' : '');
		}

		/**
		 * Returns language to be used for accessoPay
		 * @public
		 * @memberof AccessoPayUtils
		 * @param {String} language language
		 * @returns {String} accessoPay language
		 */
		function getLanguageForAccessoPay(language) {
			var langArr,
				accessoPayConfig;

			if (JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay)) {
				accessoPayConfig = JSON.parse(AppData.settings.accesso_pay);
				if (checkProp('accessoPayConfig.locale', accessoPayConfig, validString)) {
					return accessoPayConfig.locale;
				}
			}

			if (!validString(language) || language === 'en') {
				return 'en-US';
			}

			langArr = language.split('-');

			switch (langArr.length) {
			case 3:
				return [langArr[0], langArr[1], langArr[2].toUpperCase()].join('-');
			case 2:
				return [langArr[0], langArr[1].toUpperCase()].join('-');
			default:
				return language.toLowerCase();
			}
		}

		/**
		 * Returns allowed delivery countries
		 * @public
		 * @param {String} deliveryMethodId delivery method id
		 * @returns {String[]} allowed countries
		 */
		function getAllowedDeliveryCountries(deliveryMethodId) {
			var defaultCountry = checkProp('AppData.settings.default_country', AppData, 'validString') ? AppData.settings.default_country.toLowerCase() : '';
			if (!validString(deliveryMethodId) || ShippingService.isNonPhysicalDeliveryMethod(deliveryMethodId)) {
				return [];
			} else if (deliveryMethodId.toLowerCase() !== 'i') {
				return [AppData.settings.default_country];
			}

			return AppData.countries.reduce(function reduceInternationalCountries(allowedCountryCodes, currentCountry) {
				if (currentCountry.code.toLowerCase() !== defaultCountry) {
					allowedCountryCodes.push(currentCountry.code);
				}
				return allowedCountryCodes;
			}, []);
		}

		/**
		 * Returns tenant details
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {Object} tenant details
		 */
		function getTenantDetails() {
			return {
				language: service.getLanguageForAccessoPay(AppData.language),
				merchantId: service.getMerchantId(),
				sessionId: AppData.cart.session_id,
				tenantName: getTenant(AppData.island)
			}
		}

		/**
		 * Returns merchantId for accessoPay
		 * @public
		 * @returns {String} merchantId
		 */
		function getMerchantId() {
			var searchParams = angular.copy($location.search()),
				urlParams = Enums.urlParameters,
				accessoConfig = service.getAppConfig(),
				merchantOverrideParamConfig = accessoConfig.merchantOverrideParam,
				isAffiliate = checkProp('AppData.GetMerchantDetails.AFFILIATE', AppData, validObject);
			if (validString(merchantOverrideParamConfig) && validString(searchParams[merchantOverrideParamConfig])) {
				return searchParams[merchantOverrideParamConfig];
			} else if (isAffiliate && validString(searchParams[urlParams.eMerchantId])) {
				return searchParams[urlParams.eMerchantId];
			}
			return AppData.merchantId + '';
		}

		/**
		 * Returns the accesso pay configuration if any
		 * @public
		 * @returns {Object} our accesso pay configuration
		 */
		function getAppConfig() {
			if (JSONValidator.validate('accesso_pay', AppData.settings.accesso_pay)) {
				return JSON.parse(AppData.settings.accesso_pay);
			}
			return {};
		}

		/**
		 * Returns card types restricted
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {String[]} restrcited card types
		 */
		function getDisabledCardTypes() {
			var cardTypeRequired = CreditCardService.getCardTypeRequired(LegacyCart.cartItems),
				creditCardsConfigured = AppData.billingTypes.filter(function filterCreditCards(paymentType) {
					return paymentType.auth_type === AUTH_TYPE_ENUMS.CREDITCARD;
				});

			if (!validString(cardTypeRequired)) {
				return [];
			}

			return creditCardsConfigured.filter(function filterRequiredCards(paymentType) {
				return checkProp('paymentType.card_type_code', paymentType) && paymentType.card_type_code !== cardTypeRequired;
			}).map(function mapAndNormalizePaymentName(paymentType) {
				return normalize(paymentType.name).replace('discovercard', 'discover');
			});
		}

		/**
		 * Returns other configured payments
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {String[]} configured payments
		 */
		function getOtherConfiguredPayments() {
			var configuredPayments = [],
				hasCreditCards = AppData.billingTypes.some(function filterCreditCard(paymentType) {
					return paymentType.auth_type === AUTH_TYPE_ENUMS.CREDITCARD;
				}),
				hasGooglePay = CreditCardService.hasGooglePay(),
				hasApplePay = CreditCardService.hasApplePay();

			if (hasCreditCards) {
				configuredPayments.push('creditcard');
			}
			if (hasGooglePay) {
				configuredPayments.push('googlepay');
			}
			if (hasApplePay) {
				configuredPayments.push('applepay');
			}
			return configuredPayments;
		}

		/**
		 * Returns the payment methods to be disabled
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {String[]} disabled payment methods
		 */
		function getDisabledPaymentMethods() {
			var paymentMethodRequired = BillingService.getRestrictedBillingProviderNameForCart(),
				paymentMethodsConfigured = AppData.billingTypes.filter(function filterPaymentMethods(paymentType) {
					return paymentType.auth_type !== AUTH_TYPE_ENUMS.CREDITCARD;
				}),
				otherConfiguredPayments = service.getOtherConfiguredPayments(),
				matchingPaymentMethodIndex;

			if (!validString(paymentMethodRequired)) {
				return [];
			}

			paymentMethodRequired = paymentMethodRequired === Enums.paymentProvider.CREDITCARD ? 'creditcard' : service.getPaymentProviderPaymentNameMapping(paymentMethodRequired);
			matchingPaymentMethodIndex = otherConfiguredPayments.indexOf(normalize(paymentMethodRequired));

			if (matchingPaymentMethodIndex > -1) {
				otherConfiguredPayments.splice(matchingPaymentMethodIndex, 1);
				return paymentMethodsConfigured.map(function mapPaymentTypes(paymentType) {
					return normalize(paymentType.name);
				}).concat(otherConfiguredPayments);
			}

			return paymentMethodsConfigured.filter(function filterConfiguredPaymentMethods(paymentMethod) {
				return normalize(paymentMethod.name) !== normalize(paymentMethodRequired);
			}).map(function mapPaymentTypes(paymentMethod) {
				return normalize(paymentMethod.name);
			}).concat(otherConfiguredPayments);
		}

		/**
		 * Returns payment type name for restricted payment
		 * @public
		 * @memberof AccessoPayUtils
		 * @param {String} restrictedPayment restricted payment
		 * @returns {String} payment type name
		 */
		function getPaymentProviderPaymentNameMapping(restrictedPayment) {
			var restrictedAuth = BillingService.getMatchingAuthTypeForPaymentProvider(restrictedPayment),
				matchingRestrictedPayment;
			if (!validString(restrictedPayment)) {
				return '';
			} else if (restrictedPayment.indexOf('googlepay') > -1) {
				return 'googlepay';
			} else if (restrictedPayment.indexOf('applepay') > -1) {
				return 'applepay';
			}

			matchingRestrictedPayment = AppData.billingTypes.find(function findRestrictedPayment(paymentType) {
				return paymentType.auth_type === restrictedAuth;
			});
			return validObject(matchingRestrictedPayment) ? matchingRestrictedPayment.name : restrictedPayment;
		}

		/**
		 * Returns user billing demographics
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {Object} billing demographics
		 */
		function getUserBillingDemographics() {
			var billingDemographics = UserInfo.get('billing') || {};
			return {
				address1: returnOrDefault(billingDemographics.address, '', validString),
				address2: returnOrDefault(billingDemographics.address2, '', validString),
				city: returnOrDefault(billingDemographics.city, '', validString),
				country: returnOrDefault(billingDemographics.country, '', validString),
				email: returnOrDefault(billingDemographics.email, '', validString),
				firstName: returnOrDefault(billingDemographics.firstName, '', validString),
				lastName: returnOrDefault(billingDemographics.lastName, '', validString),
				middleInitial: returnOrDefault(billingDemographics.middleInitial, '', validString),
				phone: returnOrDefault(billingDemographics.phone, '', validString),
				phoneCountryCode: returnOrDefault(billingDemographics.countryCode, '', validString),
				stateProvince: returnOrDefault(billingDemographics.state, '', validString),
				zipPostal: returnOrDefault(billingDemographics.zip, '', validString)
			};
		}

		/**
		 * Returns user shipping demographics
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {Object} shipping demographics
		 */
		function getUserShippingDemographics() {
			var shippingDemographics = UserInfo.get('shipping') || {};
			return {
				address1: returnOrDefault(shippingDemographics.address || shippingDemographics.address1, '', validString),
				address2: returnOrDefault(shippingDemographics.address2, '', validString),
				city: returnOrDefault(shippingDemographics.city, '', validString),
				country: returnOrDefault(shippingDemographics.country, '', validString),
				email: returnOrDefault(shippingDemographics.email, '', validString),
				firstName: returnOrDefault(shippingDemographics.firstName, '', validString),
				lastName: returnOrDefault(shippingDemographics.lastName, '', validString),
				middleInitial: returnOrDefault(shippingDemographics.middleInitial, '', validString),
				phone: returnOrDefault(shippingDemographics.phone, '', validString),
				phoneCountryCode: returnOrDefault(shippingDemographics.countryCode, '', validString),
				stateProvince: returnOrDefault(shippingDemographics.state, '', validString),
				zipPostal: returnOrDefault(shippingDemographics.zip, '', validString)
			};
		}

		/**
		 * Return event information in accessoPay's ProductEventDetails format
		 * @public
		 * @param {Object} cartItem cart item
		 * @returns {Object} event info object
		 */
		function getEventInfoForCartItem(cartItem) {
			var eventInfo,
				productEventDetails = {};
			if (!validObject(cartItem) || !validObject(cartItem.event)) {
				return productEventDetails;
			}

			eventInfo = cartItem.event;

			[{
				accessoPayProp: 'id',
				ticketingProp: 'event_id'
			}, {
				accessoPayProp: 'startDate',
				ticketingProp: 'start_date'
			}, {
				accessoPayProp: 'startTime',
				ticketingProp: 'start_time'
			}, {
				accessoPayProp: 'endDate',
				ticketingProp: 'end_date'
			}, {
				accessoPayProp: 'endTime',
				ticketingProp: 'end_time'
			}].forEach(function addEventDetails(details) {
				if (validString(eventInfo[details.ticketingProp])) {
					productEventDetails[details.accessoPayProp] = eventInfo[details.ticketingProp];
				}
			});

			return productEventDetails;
		}

		/**
		 * Returns line items
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {Object[]} line items
		 */
		function getLineItems() {
			var lineItems = [],
				cartSummary = CartDataService.getLastSummary(),
				onlineSaving = cartSummary.pricing.savings;

			if (!validArray(cartSummary.cart.items)) {
				return lineItems;
			}

			cartSummary.cart.items.forEach(function addCartItemAsLineItem(cartItem) {
				var packageDetails = Package.getPackageByID(cartItem.package.id) || {},
					customerTypeDetails = wrapObjectToArray(packageDetails.CT, true).find(function findCustomerType(ct) {
						return checkProp('ct.id', ct, 'validString') && ct.id === returnOrDefault(cartItem.customer.id, '', validString);
					}),
					paymentScheduleDetails = checkProp('customerTypeDetails.PAYMENT_SCHEDULE', customerTypeDetails, 'validObject') ? customerTypeDetails.PAYMENT_SCHEDULE : {},
					hasEventInfo = validObject(cartItem.event),
					lineItemQty = cartItem.info.qty,
					firstPaymentSchedule,
					lineItemDetails = {
						feeAmount: cartItem.pricing.fee,
						productDescription: validObject(packageDetails) ? packageDetails.package_class : '',
						productName: cartItem.package.name,
						productSKU: cartItem.package.id,
						quantity: lineItemQty,
						taxAmount: cartItem.pricing.tax,
						unitPrice: cartItem.pricing.retail
					};

				if (cartItem.flags.hasPaymentPlan && paymentScheduleDetails.id === cartItem.paymentPlan.id && checkProp('paymentScheduleDetails.SP', paymentScheduleDetails, 'validArray')) {
					firstPaymentSchedule = paymentScheduleDetails.SP[0];
					lineItemDetails.feeAmount = parseFloat(firstPaymentSchedule.fee_amount) * lineItemQty;
					lineItemDetails.taxAmount = parseFloat(firstPaymentSchedule.tax_amount) * lineItemQty;
					lineItemDetails.unitPrice = parseFloat(firstPaymentSchedule.retail_amount) * lineItemQty;
				}

				if (hasEventInfo) {
					lineItemDetails.eventInfo = service.getEventInfoForCartItem(cartItem);
				}
				lineItems.push({
					details: lineItemDetails,
					type: 'lineitem'
				});
			});

			if (onlineSaving) {
				lineItems.push({
					details: {
						amount: onlineSaving,
						label: getLocale('Cart', 'onlineSavings')
					},
					type: 'discount'
				});
			}

			lineItems.push({
				details: {
					amount: cartSummary.pricing.subtotal,
					label: getLocale('CartView', 'subtotal')
				},
				type: 'subtotal'
			}, {
				details: {
					amount: cartSummary.pricing.currentTax || cartSummary.pricing.taxTotal,
					label: getLocale('CartView', 'taxLabel')
				},
				type: 'tax'
			}, {
				details: {
					amount: parseFloat(service.getAmountForPayment()),
					label: getLocale('CartView', 'totalLabel')
				},
				type: 'total'
			});

			return lineItems.concat(service.getFeesDetailsForCart());
		}

		/**
		 * Return fees for the cart
		 * @public
		 * @returns {Object[]} fee details
		 */
		function getFeesDetailsForCart() {
			var cartSummary = CartDataService.getLastSummary();
			var cartAdjustments = cartSummary.adjustments,
				cartFees = cartSummary.fees,
				feeDetails = [];

			cartAdjustments.forEach(function addCartAdjustments(ca) {
				var caAmount = ca.amount,
					caTaxAmount = ca.tax;
				if (caAmount > 0 || caTaxAmount > 0) {
					feeDetails.push({
						details: {
							amount: caAmount,
							label: getLocale('CartView', 'cartAdjustment' + ca.id),
							tax: caTaxAmount || 0
						},
						type: 'fee'
					});
				}
			});

			cartFees.forEach(function addFees(fee) {
				feeDetails.push({
					details: {
						amount: fee.asTax ? 0 : parseFloat(fee.amount),
						label: getLocale('CartView', 'fee' + fee.id),
						tax: fee.asTax ? parseFloat(fee.amount) : 0
					},
					type: 'fee'
				});
			});

			return feeDetails;
		}

		/**
		 * Broadcast analytics event
		 * @public
		 * @memberof AccessoPayUtils
		 * @param {String} eventName eventName
		 * @param {String} eventValue eventValue
		 * @returns {undefined}
		 */
		function broadcastAnalyticsEvent(eventName, eventValue) {
			$rootScope.$broadcast(eventName, eventValue);
		}

		/**
		 * Returns the amount to be paid
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {String} amount to be paid
		 */
		function getAmountForPayment() {
			var cartSummary = CartDataService.getLastSummary();
			var partialPayments;

			if (cartSummary.pricing.depositTotal) {
				return cartSummary.pricing.depositTotal;
			}

			// If there is a partial payment indicator, do calculation the left over amount
			if (UserInfo.partialPaymentsIndicator) {
				partialPayments = UserInfo.get('partialPayments');

				return partialPayments.reduce(function(total, partialPayment) {
					if (checkProp('partialPayment.payment.total', partialPayment)) {
						return total - parseFloat(partialPayment.payment.total);
					}
					return total;
				}, cartSummary.pricing.total);
			}

			if (cartSummary.info.hasPaymentSchedule) {
				return cartSummary.pricing.currentDue;
			}

			return cartSummary.pricing.total;
		}

		/**
		 * Check if the cart has scheduled payments
		 * @public
		 * @memberof AccessoPayUtils
		 * @returns {Boolean} true for deferred payments
		 */
		function hasScheduledPayments() {
			return checkProp('AppData.GetCartSummary.PAYMENT_SCHEDULE.PAYMENT', AppData, validArray);
		}

		/**
		 * Returns URL origin without file path
		 * @public
		 * @memberof AccessoPayPrepService
		 * @param {String} link link
		 * @returns {String} url origin
		 */
		function parseUrlOrigin(link) {
			if (validString(link)) {
				try {
					return new URL(link).origin;
				} catch (err) {
					return '';
				}
			}
			return '';
		}
	}
}());